import $ from 'jquery';

function initForm (eventOptions, categoryOptions) {
  $(eventOptions).filter(':checked').change();
  $(categoryOptions).filter(':checked').change();
}

function toggleHotelOptions (noHotel, hotelComponents, noHotelField) {
  let hasHotel = !noHotel;
  hotelComponents.toggleClass('hidden', !hasHotel);
  $('input', hotelComponents).prop('disabled', !hasHotel);
  noHotelField.val(!hasHotel);
}

function setHotelOptions (selectedCategory, categoryHotelContainer, hotelOptions) {
  const selectedHotel = $(hotelOptions).filter(':checked').val();

  categoryHotelContainer.addClass('hidden');
  const categoryContainer = categoryHotelContainer.filter(`[data-category="${selectedCategory}"]`);
  categoryContainer.removeClass('hidden');

  const hotelOption = $(`[value="${selectedHotel}"]`, categoryContainer);
  if (hotelOption.length) {
    hotelOption.prop('checked', true);
  } else {
    hotelOptions.last().prop('checked', true);
  }
}

function toggleBookedupHotels (hotelOptions, selectedEvent, wrapper) {
  const bookedUpHotels = $(selectedEvent).data('booked-up-hotels') || [];
  $(hotelOptions).each(function () {
    const optionWrapper = $(this).parent('.radio-btn');
    const isBookedUp = bookedUpHotels.includes($(this).data('hotel-id'));
    $(this).prop('disabled', isBookedUp);
    optionWrapper.toggleClass('hidden', isBookedUp);
  });
}

function toggleBookedupCategories (categoryOptions, categoryHotelContainer) {
  $(categoryOptions).each(function () {
    const categoryOption = $(this);
    const category = categoryOption.val();
    const categoryContainer = categoryHotelContainer.filter(`[data-category="${category}"]`);
    const isCategoryBookedUp = $('.radio-btn:not(.hidden)', categoryContainer).length === 0;

    categoryOption.prop('disabled', isCategoryBookedUp);
    if (categoryOption.is(':checked') && isCategoryBookedUp) {
      categoryOption.prop('checked', false);
    }
  });
}

export default function () {
  const wrapper = $('#booking-form');
  if (wrapper.length === 0) {
    return;
  }

  const hotelOptions = $('input[name=hotel]', wrapper);
  const eventOptions = $('input[name=event]', wrapper);
  const categoryOptions = $('input[name=category]', wrapper);
  const categoryHotelContainer = $('[data-category]', wrapper);
  eventOptions.change(function () {
    const selectedEvent = $(this);
    toggleBookedupHotels(hotelOptions, selectedEvent);
    toggleBookedupCategories(categoryOptions, categoryHotelContainer);
  });

  const hotelComponents = $('.hotel-components', wrapper);
  const noHotelField = $('input[name=no_hotels]', wrapper);
  categoryOptions.change(function () {
    setHotelOptions($(this).val(), categoryHotelContainer, hotelOptions);
    toggleHotelOptions($(this).data('no_hotel'), hotelComponents, noHotelField);
  });

  initForm(eventOptions, categoryOptions);

  $('input:invalid', wrapper).on('invalid', function () {
    const invalidField = $('input:invalid').first();
    const offset = $('.header-wrapper').height() + 100;
    const delay = 0;
    $('html, body').animate({ scrollTop: invalidField.offset().top - offset }, delay);
  });
}
